// src/components/admin/settings/SocialLinks.jsx
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Globe } from 'lucide-react';
import styles from '../../../styles/Settings.module.css';
import useTranslation from '../../../hooks/useTranslation';
import { updatePlatformInfo, selectSocialLinks } from '../../../store/slices/platformSettingsSlice';
import toast from 'react-hot-toast';

const SocialLinks = () => {
  const dispatch = useDispatch();
  const socialLinksRedux = useSelector(selectSocialLinks);

  const { translatedText: socialLinks } = useTranslation('Social Links');
  const { translatedText: facebook } = useTranslation('Facebook');
  const { translatedText: instagram } = useTranslation('Instagram');
  const { translatedText: twitter } = useTranslation('Twitter / X');
  const { translatedText: youtube } = useTranslation('YouTube');
  const { translatedText: linkedin } = useTranslation('LinkedIn');

  const [localLinks, setLocalLinks] = React.useState(
    socialLinksRedux || {
      facebook: '',
      instagram: '',
      twitter: '',
      youtube: '',
      linkedin: ''
    }
  );

  React.useEffect(() => {
    if (socialLinksRedux) {
      setLocalLinks(socialLinksRedux);
    }
  }, [socialLinksRedux]);

  const handleChange = (field, value) => {
    setLocalLinks(prev => ({ ...prev, [field]: value }));
  };

  const handleSave = async () => {
    try {
      await dispatch(updatePlatformInfo({ socialLinks: localLinks })).unwrap();
      toast.success('Social links saved!');
    } catch (error) {
      toast.error(error || 'Failed to save settings');
    }
  };

  return (
    <div className={styles.settingsCard}>
      <h3>
        <Globe size={20} />
        {socialLinks || 'Social Media Links'}
      </h3>
      <div className={styles.settingsForm}>
        <div className={styles.formGroup}>
          <label>📘 {facebook || 'Facebook'}</label>
          <input
            type="url"
            value={localLinks.facebook}
            onChange={(e) => handleChange('facebook', e.target.value)}
            placeholder="https://facebook.com/yourpage"
          />
        </div>
        <div className={styles.formGroup}>
          <label>📸 {instagram || 'Instagram'}</label>
          <input
            type="url"
            value={localLinks.instagram}
            onChange={(e) => handleChange('instagram', e.target.value)}
            placeholder="https://instagram.com/yourpage"
          />
        </div>
        <div className={styles.formGroup}>
          <label>🐦 {twitter || 'Twitter / X'}</label>
          <input
            type="url"
            value={localLinks.twitter}
            onChange={(e) => handleChange('twitter', e.target.value)}
            placeholder="https://twitter.com/yourpage"
          />
        </div>
        <div className={styles.formGroup}>
          <label>▶️ {youtube || 'YouTube'}</label>
          <input
            type="url"
            value={localLinks.youtube}
            onChange={(e) => handleChange('youtube', e.target.value)}
            placeholder="https://youtube.com/yourchannel"
          />
        </div>
        <div className={styles.formGroup}>
          <label>💼 {linkedin || 'LinkedIn'}</label>
          <input
            type="url"
            value={localLinks.linkedin}
            onChange={(e) => handleChange('linkedin', e.target.value)}
            placeholder="https://linkedin.com/company/yourcompany"
          />
        </div>
        <button className={styles.saveBtn} onClick={handleSave}>Save Changes</button>
      </div>
    </div>
  );
};

export default SocialLinks;